import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { NotificationType } from './types'

export const useNotification = defineStore('notification', () => {
  const notifications = ref<NotificationType[]>([])

  const add = (notification: NotificationType) => {
    notification.id = Math.random().toString(16).slice(2)

    notifications.value.push(notification)
  }

  const addSuccess = (message: string, notification?: NotificationType) => {
    const not: NotificationType = {
      message: message,
      type: 'success',

      ...notification,
    }

    add(not)
  }

  const addError = (message: string, notification?: NotificationType) => {
    const not: NotificationType = {
      message: message,
      type: 'error',

      ...notification,
    }

    add(not)
  }

  const addWarning = (message: string, notification?: NotificationType) => {
    const not: NotificationType = {
      message: message,
      type: 'warning',

      ...notification,
    }

    add(not)
  }

  const remove = (id: string) => {
    notifications.value = notifications.value.filter((item) => item.id !== id)
  }

  return {
    notifications,

    add,
    addSuccess,
    addError,
    addWarning,
    remove,
  }
})
